<template>
  <b-card>
    <b-row>
      <b-col>
        <h3 class="mb-2">
          Create a new {{ companyPurpose !== 'rent' ? 'order' : 'booking' }}
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div
            v-if="isLoading"
            class="text-center py-2"
        >
          <b-spinner label="Loading..." />
        </div>

        <div v-if="isCreateLoading" class="modal-overlay d-flex align-items-center justify-content-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <b-form class="d-flex flex-column">

          <b-row v-if="companyPurpose !== 'rent'" class="py-2">
            <template v-if="companyPurpose === 'service'">
              <b-col cols="12" v-show="showServicesBlock">
                <Services
                    :services="services"
                    :sale="null"
                    @update:services="updateServices"
                />
              </b-col>
              <b-col
                v-if="showProductsToggle"
                cols="12"
                :class="showServicesBlock ? 'mt-2' : ''"
              >
                <b-button variant="outline-primary" @click="showProductsBlock = true">
                  Add products
                </b-button>
              </b-col>
              <b-col cols="12" :class="showServicesBlock || showProductsToggle ? 'mt-2' : ''" v-show="showProductsBlock">
                <Products
                    :products="products"
                    :sale="null"
                    @update:products="updateProducts"
                />
              </b-col>
            </template>
            <template v-else>
              <b-col cols="12" v-show="showProductsBlock">
                <Products
                    :products="products"
                    :sale="null"
                    @update:products="updateProducts"
                />
              </b-col>
              <b-col
                v-if="showServicesToggle"
                cols="12"
                :class="showProductsBlock ? 'mt-2' : ''"
              >
                <b-button variant="outline-primary" @click="showServicesBlock = true">
                  Add services
                </b-button>
              </b-col>
              <b-col cols="12" :class="showProductsBlock || showServicesToggle ? 'mt-2' : ''" v-show="showServicesBlock">
                <Services
                    :services="services"
                    :sale="null"
                    @update:services="updateServices"
                />
              </b-col>
            </template>
            <p class="text-danger p-1" v-if="lineItemsValidation === false">Product or service is required.</p>
          </b-row>

          <b-row v-show="hasLineItems">
            <b-col
              v-if="!isServicesOnly"
              cols="12"
              lg="4"
            >
              <b-container class="px-0">
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                        :label="'In store pick up'"
                        label-for="pickup"
                    >
                      <b-form-checkbox v-model="form.pickup" switch class="mb-1">

                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="6">
                    <b-form-group
                        :label="'Delivery'"
                        label-for="delivery"
                    >
                      <b-form-checkbox v-model="form.delivery" switch class="mb-1">

                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col
              cols="12"
              md="6"
              :lg="isServicesOnly ? 6 : 4"
            >
              <b-form-group
                  :label="orderDateLabel"
                  label-for="input-date"
              >
                <b-form-datepicker
                    id="input-date"
                    v-model="form.date"
                    :min="minDate"
                    :date-disabled-fn="dateDisabled"
                    :disabled="isDatepickerDisabled"
                    :placeholder="datepickerPlaceholder"
                    locale="en"
                    :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"
                    @input="datepickerUpdated"
                />
                <small class="text-danger" v-if="v$.form.date.$error">Date is required.</small>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              md="6"
              :lg="isServicesOnly ? 6 : 4"
            >
              <b-form-group
                  :label="orderTimeIntervalLabel"
                  label-for="time-interval"
              >
                <b-form-input
                    id="time-interval"
                    v-model="form.time_interval"
                    placeholder="any time"
                    maxlength="50"
                />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="py-2" v-show="hasLineItems">
            <b-col cols="12">
              <small v-if="form.pickup || isServicesOnly" class="text-muted d-block mb-1">Customer is optional for in-store pickup.</small>
              
              <Customers
                  :customer="form.customer"
                  @update:customer="updateCustomer"
              />
              <p class="text-danger p-1" v-if="v$.form.customer.$error">Customer is required for delivery orders.</p>
            </b-col>
          </b-row>

          <b-row v-if="companyPurpose === 'rent'">
            <b-col cols="6">
              <b-form-group
                  :label=" companyPurpose !== 'rent' ? 'Product' : 'Unit' "
                  label-for="select-unit"
              >
                <v-select
                    id="select-unit"
                    v-model="form.unit"
                    :placeholder="`Select ${(companyPurpose !== 'rent' ? 'Product' : 'Unit')}`"
                    label="name"
                    :options="units"
                    :clearable="false"
                />
                <!--[ { name: 'Please select', value: null }, ...units ]-->
                <small class="text-danger" v-if="v$.form.unit.$error">Required.</small>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                  :label="'Package ' + (companyPurpose === 'rent' ? '(choose a Package, or set price and duration manually)' : '')"
                  label-for="select-package-name"
                  v-if="packageNames.length > 0"
              >
                <v-select
                    id="select-package-name"
                    v-model="form.packageName"
                    placeholder="Select package"
                    label="text"
                    :options="packageNames"
                    :clearable="false"
                />
                <small class="text-danger d-block">{{ /*errors[0]*/ '' }}</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="companyPurpose !== 'rent'" v-show="!isServicesOnly && form.customer !== null && form.delivery">
            <b-col class="py-2">
              <h5>Delivery address</h5>
              <b-container class="border my-1 p-1">
                <b-row class="w-100">
                  <b-col cols="12" lg="6">
                    <b-form-group label="Country" label-for="customer_address_country">
                      <CountrySelect
                          input-id="customer_address_country"
                          v-model="form.customer_address_country_id"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Region"
                        label-for="customer_address_region"
                        class="mb-2"
                    >
                      <RegionSelect
                          input-id="customer_address_region"
                          v-model="form.customer_address_region_id"
                          :country-id="form.customer_address_country_id"
                          :clearable="false"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="City"
                        label-for="customer_address_city"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_city"
                          v-model="form.customer_address_city"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Postal code"
                        label-for="customer_address_zip_code"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_zip_code"
                          v-model="form.customer_address_zip_code"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Address line 1"
                        label-for="customer_address_line_1"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_line_1"
                          v-model="form.customer_address_line_1"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Address line 2"
                        label-for="customer_address_line_2"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_line_2"
                          v-model="form.customer_address_line_2"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Name"
                        label-for="customer_address_name"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_name"
                          v-model="form.customer_address_name"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6">
                    <b-form-group
                        label="Phone"
                        label-for="customer_address_phone"
                        class="mb-2"
                    >
                      <b-form-input
                          id="customer_address_phone"
                          v-model="form.customer_address_phone"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
          </b-row>
          

          <b-form-group
              v-if="companyPurpose === 'rent'"
              label="How Many People Will Be In This Group?:"
              label-for="input-details"
              class="mb-2"
          >
            <b-form-input
                id="input-details"
                v-model="form.details"
                placeholder="0"
                type="number"
            />
          </b-form-group>


          <b-form-group
              v-if="companyPurpose === 'rent'"
              label="Duration in hours (if set, overwrites package duration)" label-for="duration"
          >
            <b-form-input type="number" v-model="form.duration" placeholder="Duration in hours" />
            <small class="text-danger" v-if="v$.form.duration.$error">Duration is numeric.</small>
          </b-form-group>


          <b-row v-show="hasLineItems">
            <b-col
              cols="12"
              md="3"
            >
              <b-form-group
                label="Payment Status"
                label-for="payment_status"
              >
                <v-select
                    id="status-select"
                    v-model="form.payment_status"
                    label="name"
                    :options="createSalePaymentStatuses"
                    :clearable="false"
                />
                <small class="text-danger" v-if="v$.form.payment_status.$error">Payment Status is required.</small>
              </b-form-group>
            </b-col>
          </b-row>


          <b-row
            v-show="hasLineItems"
            v-if="form.payment_status != null && (form.payment_status.id == 1 || form.payment_status.id == 2 || form.payment_status.id == 3 || form.payment_status.id == 4 || form.payment_status.id == 7)"
          >
            <b-col cols="6">
              <b-form-group label="Paid Amount" label-for="paid-amount">
                <b-form-input
                    id="paid-amount"
                    type="number"
                    v-model="form.paid"
                    :readonly="form.payment_status.id === 3"
                    v-if="true"
                /> <!--v-if="form.payment_status.id !== 4"-->
                <span v-else>{{ $formatCurrency(form.subtotal !== null ? calcTotal() : 0, null) }}</span>
                <small class="text-danger" v-if="v$.form.paid.$error">Paid amount is required.</small>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Payment Method" label-for="payment-method">
                <v-select
                    id="payment-method"
                    class="mb-1"
                    v-model="form.payment_method"
                    label="text"
                    :options="paymentMethods"
                    :clearable="false"
                />
                <small class="text-danger" v-if="v$.form.payment_method.$error">Payment method is required.</small>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-show="hasLineItems">
            <b-col cols="12" lg="3">
              <b-form-group :label="(companyPurpose !== 'rent' ? 'Subtotal' : 'Price per hour') +' '" label-for="subtotal">
                <b-form-input
                    type="number"
                    v-model="form.subtotal"
                    :placeholder="companyPurpose !== 'rent' ? '' : 'Price per hour'"
                    readonly
                />
                <small class="text-danger" v-if="v$.form.subtotal.$error">Subtotal is numeric</small>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="2">
              <b-form-group :label="(companyPurpose !== 'rent' ? 'Shipping' : 'Delivery') + ' '" label-for="shipping" v-show="showShipping">
                <b-form-input
                    type="number"
                    v-model="form.shipping"
                    min="0"
                />
                <small class="text-danger" v-if="v$.form.shipping.$error">Must be numeric</small>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="2">
              <b-form-group :label="'Discount (in %)'" label-for="discount">
                <b-form-input
                    type="number"
                    v-model="form.discount"
                    :placeholder="'Discount in %, will apply on total'"
                    max="99"
                    min="0"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="2">
              <b-form-group
                v-show="Number(saleTax?.value || 0) !== 0"
                :label="'Tax (' + saleTax.name + ')'"
              >
                <span>{{ saleTax.value }}%</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="3">
              <b-form-group :label="'Total'">
                <span>{{ $formatCurrency(calcTotal()) }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-show="false && hasLineItems">
            <b-col cols="12">
              <b-form-group :label="`Repeat this ${(companyPurpose !== 'rent' ? 'order' : 'booking')}`" label-for="repeat">
                <v-select
                    id="repeat-select"
                    v-model="form.repeat"
                    :options="Object.values(repeatSelect)"
                    :clearable="true"
                />
              </b-form-group>
              <b-form-group label-for="details" v-if="form.repeat !== null" :label="`Repeat details (${repeatSamples[form.repeat]})`">
                <b-form-input
                    v-model="form.repeat_details"
                    id="repeat-details"
                />
              </b-form-group>
            </b-col>
          </b-row>
          
          
          <b-row v-show="hasLineItems" class="border-top pt-1">
            <b-col cols="12">
              <b-form-group
                  label-for="customer_note"
                  v-show="hasLineItems"
              >
                <template #label>
                  <span
                      class="collapsible-field-label"
                      role="button"
                      @click="showCustomerNote = !showCustomerNote"
                  >
                    Customer note
                    <feather-icon
                        class="ml-1 collapsible-field-icon"
                        size="16"
                        :icon="showCustomerNote ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                    />
                  </span>
                </template>
                <b-form-textarea
                    v-show="showCustomerNote"
                    id="customer_note"
                    v-model="form.customer_note"
                    placeholder="Customer note"
                    rows="3"
                    max-rows="6"
                />
              </b-form-group>

              <b-form-group
                  label-for="description"
                  v-show="hasLineItems"
              >
                <template #label>
                  <span
                      class="collapsible-field-label"
                      role="button"
                      @click="showSpecialNotes = !showSpecialNotes"
                  >
                    Special notes / Description
                    <feather-icon
                        class="ml-1 collapsible-field-icon"
                        size="16"
                        :icon="showSpecialNotes ? 'ChevronUpIcon' : 'ChevronDownIcon'"
                    />
                  </span>
                </template>
                <b-form-textarea
                    v-show="showSpecialNotes"
                    id="description"
                    v-model="form.description"
                    placeholder="Description"
                    rows="3"
                    max-rows="6"
                />
              </b-form-group>
            </b-col>
          </b-row>

          
          
          <b-row v-show="hasLineItems" class="border-top pt-1">
            <b-col cols="12" lg="6">
              <b-form-group
                  :label="'Send invoice to customer'"
                  label-for="send_invoice"
              >
              <b-form-checkbox v-model="form.send_invoice" switch class="mb-1" :disabled="!form.customer">

              </b-form-checkbox>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" class="text-lg-right">
              <b-button
                  variant="primary"
                  class="align-self-end w-100 w-md-50 w-lg-25 w-xl-25"
                  :disabled="isCreateLoading"
                  @click="onSubmit"
              >
                <b-spinner
                    v-if="isCreateLoading"
                    label="Processing"
                    small
                    class="mr-50"
                />
                <span>{{ isCreateLoading ? 'Processing...' : 'Create' }}</span>
              </b-button>
            </b-col>
          </b-row>

        </b-form>

      </b-col>
    </b-row>
  </b-card>
</template>

<script>

import useVuelidate from '@vuelidate/core';
import { required, numeric, integer, minValue, minLength, email, helpers, requiredIf } from '@vuelidate/validators';
import VueNumberInput from '@chenfengyuan/vue-number-input';

import vSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BFormGroup,
  BFormInput,
  BForm,
  BSpinner,
  BFormDatepicker,
  BFormTextarea,
  BFormCheckbox,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { toastSuccess, toastFailure } from '@/libs/toastification'
import axios from '@/libs/axios'
import {checkReservedDate, isTimeSelectable} from "@/libs/reserved-dates";
import {HALF_DAY_PACKAGE, HARBOR_CRUISE, TEASER_ID} from "@/constants/package-types.enum";
import {SALE_PAYMENT_STATUSES, PAYMENT_METHODS} from "@/constants/enums";
import {SALE_REPEATS, SALE_REPEAT_SAMPLES} from "@/constants/enums";
import Products from "@/views/Components/Products.vue";
import Services from "@/views/Components/Services.vue";
import Customers from "@/views/Components/Customers.vue";
import CountrySelect from '@/views/Components/Elements/CountrySelect.vue';
import RegionSelect from '@/views/Components/Elements/RegionSelect.vue';
import { moneyRound, calcSaleTotal, applyCustomerAddressToForm } from '@/libs/utils';
import { companyTodayYmd } from '@/libs/companyTime'

export default {
  components: {
    Customers,
    Products,
    Services,
    CountrySelect,
    RegionSelect,
    BFormCheckbox,
    BFormTextarea,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormGroup,
    BFormInput,
    BForm,
    BSpinner,
    vSelect,
    BFormDatepicker,
    VueNumberInput
  },
  data() {
    return {
      lineItemsValidation: null,
      showShipping: true,
      showCustomerNote: false,
      showSpecialNotes: false,
      inputReadonly: true,
      locations: [],
      products: [],
      services: [],
      supplierProducts: [],
      selected: "",
      count: 0,
      isDragging: false,
      dragOptions: {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      },
      paymentMethods: PAYMENT_METHODS,
      statusSelect: SALE_PAYMENT_STATUSES,
      repeatSelect: SALE_REPEATS,
      repeatSamples: SALE_REPEAT_SAMPLES,
      showProductsBlock: true,
      showServicesBlock: false,
      companyPurpose: window.companyPurpose,
      companyId: window.companyId,
      saleTax: window.saleTax,
      isLoading: true,
      form: {
        unit: null,
        unitObject:null,
        packageName: null,
        beforePackageName: null,
        date: null,
        time: null,

        customer: null,
        customer_address_id: null,
        customer_address_country_id: window.companyCountryId ?? null,
        customer_address_region_id: null,
        customer_address_city: null,
        customer_address_line_1: null,
        customer_address_line_2: null,
        customer_address_zip_code: null,
        customer_address_name: null,
        customer_address_description: null,
        customer_address_phone: null,

        details: null,
        packages: null,
        subtotal: null,
        shipping: 0,
        duration: null,
        description: null,
        customer_note: null,
        payment_status: null,
        pickup: false,
        delivery: false,
        repeat: null,
        repeat_details: null,
        paid: null,
        payment_method: null,
        send_invoice: false,
        discount: 0,
        time_interval: null
      },
      minDate: new Date(),
      datepickerPlaceholder: 'No date selected',
      isDatepickerDisabled: false,
      blockDates: [],
      //required,
      //email,
      HALF_DAY_PACKAGE, HARBOR_CRUISE, TEASER_ID,
      isCreateLoading: false,
      firstApril2022: new Date(2022, 4, 1),
      thisUnitPackageNameId:[],
    }
  },
  computed: {
    ...mapGetters({
      units: 'units/units',
      companySettings: 'companies/companySettings',
    }),
    acceptPartialPayments() {
      return !!(this.companySettings && this.companySettings.accept_partial_payments)
    },
    createSalePaymentStatuses() {
      const statuses = Object.values(this.statusSelect)

      if (!this.acceptPartialPayments) {
        return statuses.filter((status) => status.id === 0 || status.id === 3)
      }

      return statuses.filter((status) => status.id !== 4 && status.id !== 5)
    },
    hasActiveProducts() {
      return (this.products || []).some((product) => Number(product.items_quantity) > 0)
    },
    hasActiveServices() {
      return (this.services || []).some((service) => Number(service.items_quantity) > 0)
    },
    hasLineItems() {
      return this.hasActiveProducts || this.hasActiveServices
    },
    showProductsToggle() {
      return this.companyPurpose === 'service' && !this.showProductsBlock
    },
    showServicesToggle() {
      return this.companyPurpose !== 'service' && !this.showServicesBlock
    },
    isServicesOnly() {
      return this.companyPurpose !== 'rent' && !this.hasActiveProducts && this.hasActiveServices
    },
    orderDateLabel() {
      if (this.companyPurpose === 'rent') {
        return 'Date'
      }
      if (this.isServicesOnly) {
        return 'Delivery date'
      }
      return (this.form.pickup ? 'Pickup' : 'Delivery') + ' date'
    },
    orderTimeIntervalLabel() {
      if (this.companyPurpose === 'rent') {
        return 'Time interval'
      }
      if (this.isServicesOnly) {
        return 'Delivery time interval'
      }
      return (this.form.pickup ? 'Pickup' : 'Delivery') + ' time interval'
    },
    packageNames() {

      const selectedUnitPackageNameId = [];
      const packages = [];
      let that = this;

      if (this.form.unit != null && this.units[this.form.unit.id - 1] != undefined) {

        this.units[this.form.unit.id - 1].packages.map(function(unitPackage){
          selectedUnitPackageNameId[unitPackage.name] = unitPackage.id;
          if( unitPackage.inactive === 0 ) {
            packages.push(unitPackage.name);
          }
        });
      }

      this.thisUnitPackageNameId = selectedUnitPackageNameId;
      return packages
    },
    times() {
      const timeOptions = [
        {
          value: '06:00:00',
          text: '6 AM',
          selectable: isTimeSelectable("6 AM", this.blockDates, this.form),
        },
        {
          value: '12:00:00',
          text: '12 PM',
          selectable: isTimeSelectable("12 PM", this.blockDates, this.form),
        }
      ];

      if (this.form.packageName === HARBOR_CRUISE) {
        timeOptions.push({
          value: '18:00:00',
          text: '6 PM',
          selectable: isTimeSelectable("6 PM", this.blockDates, this.form),
        });
      }

      return timeOptions;
    },
  },
  watch: {
    'form.unit': function () {
      this.loadBlockDates()
      this.form.packageName = null
    },
    'form.subtotal': function () {
      this.setPaidAmount();
    },
    'form.payment_status': function () {
      this.setPaidAmount();
    },
    'form.shipping'(value) {
      if (value !== null && value !== '') {
        const rounded = moneyRound(value);
        if (Number(value) !== rounded) {
          this.form.shipping = rounded;
          return;
        }
      }
      this.setPaidAmount();
    },
    'form.discount': function () {
      this.setPaidAmount();
    },
    'form.pickup': function () {

      if (this.form.pickup) {
        this.form.delivery = false;
        this.form.shipping = 0;
        this.showShipping = false;
        this.form.send_invoice = false;
      }
    },
    'form.delivery': function () {

      if (this.form.delivery) {
        this.form.pickup = false;
        this.showShipping = true;
      }
    },
    'form.packageName': function () {
      this.loadBlockDates()
    },
    products : function () {
      this.recalculateSubtotal()
    },
    services : function () {
      this.recalculateSubtotal()
    },
    isServicesOnly(value) {
      if (value) {
        this.form.pickup = true
        this.form.delivery = false
        this.form.shipping = 0
        this.showShipping = false
        this.form.send_invoice = false
      } else if (this.hasLineItems && this.companyPurpose !== 'rent') {
        this.showShipping = !this.form.pickup
      }
    },
  },
  async mounted() {
    try {
      await this.loadCompanySettings().catch(() => {})
      this.applyOrderSettingsFromCompany()

      if (this.companyPurpose === 'rent') {
        await this.loadUnits()
      }
    } catch {
      toastFailure('Something went wrong in general')
    } finally {
      this.isLoading = false
    }
  },
  validations() {

    return {
      form: {
        payment_status: { required },
        date: { required },
        packageName: { required: requiredIf(function() {
            return this.form.subtotal == null && this.form.duration == null && companyPurpose === 'rent' ? true : false;
          })
        },
        paid: { numeric, greaterThanZero: this.greaterThan(0), required: requiredIf( function () {
            return this.form.payment_status.id === 1 || this.form.payment_status.id === 2 || this.form.payment_status.id === 3 || this.form.payment_status.id === 4 ? true : false;
          })
        },
        payment_method: { required: requiredIf( function () {
            return this.form.payment_status.id === 1 || this.form.payment_status.id === 2 || this.form.payment_status.id === 3 || this.form.payment_status.id === 4 ? true : false;
          })
        },
        /*unit: { required: requiredIf(function() {
            return companyPurpose !== 'rent' ? true : false;
          })
        },*/
        customer: { required: requiredIf(function () {
          return !this.form.pickup;
        }) },
        subtotal: { numeric, required: requiredIf(function() {
            return this.form.packageName == null && companyPurpose === 'rent' ? true : false;
          })
        },
        shipping: { numeric, minValue: minValue(0) },
        discount: { numeric, minValue: minValue(0) },
        duration: { numeric, required: requiredIf(function() {
            return this.form.packageName == null && companyPurpose === 'rent' ? true : false;
          })
        }
      }
    };
  },
  setup() {
    return { v$: useVuelidate() };
  },
  methods: {
    ...mapActions({
      createSaleManually: 'sales/createSaleManually',
      loadUnits: 'units/loadUnits',
      loadCompanySettings: 'companies/loadCompanySettings',
    }),
    applyOrderSettingsFromCompany() {
      if (!this.companySettings) {
        return
      }

      this.companyPurpose = this.companySettings.purpose || this.companyPurpose
      this.showProductsBlock = this.companyPurpose !== 'service'
      this.showServicesBlock = this.companyPurpose === 'service'

      if (!this.acceptPartialPayments) {
        this.form.payment_status = this.statusSelect[0]
        this.setPaidAmount()
      }

      if (this.companyPurpose === 'rent') {
        return
      }

      const orderType = this.companySettings.default_order_type || 'delivery'

      if (orderType === 'pickup') {
        this.form.pickup = true
        this.form.delivery = false
        this.form.shipping = 0
        this.showShipping = false
        this.form.date = this.todayDateString()
        return
      }

      this.form.delivery = true
      this.form.pickup = false
      this.showShipping = true
      this.form.date = null
    },
    todayDateString() {
      return companyTodayYmd()
    },
    setPaidAmount () {

      if (this.form.payment_status === null) {
        return;
      }

      if (this.form.payment_status.id === 3) {
        this.form.paid = this.calcTotal();
      } else {
        if (this.form.paid > 0) {
          this.form.paid = null;
        }
      }
    },
    calcTotal () {

      if (this.form.discount > 99) {
        this.form.discount = 99;
      }

      if (this.form.discount < 0) {
        this.form.discount = 0;
      }

      return calcSaleTotal(this.form, this.saleTax.value);
    },
    greaterThan(min) {
      // Returns a validator function
      return value => {
        // Check the condition based on other form fields
        if (this.form.payment_status.id === 2 || this.form.payment_status.id === 3) {
          return value > min; // Value must be greater than zero
        }
        return true; // No validation if condition is not met
      };
    },
    updateProducts(updatedProducts) {
      this.products = updatedProducts;
    },
    updateServices(updatedServices) {
      this.services = updatedServices;
    },
    recalculateSubtotal() {
      let totalPrice = 0;
      this.products.forEach((product) => {
        if (product.items_quantity > 0) {
          totalPrice = moneyRound(totalPrice + product.items_quantity * product.price);
        }
      });
      this.services.forEach((service) => {
        if (service.items_quantity > 0) {
          totalPrice = moneyRound(totalPrice + service.items_quantity * service.price);
        }
      });
      this.form.subtotal = totalPrice;
    },
    updateCustomer(updatedCustomer) {
      this.form.customer = updatedCustomer;

      if (!updatedCustomer) {
        return;
      }

      applyCustomerAddressToForm(this.form, updatedCustomer, window.companyCountryId);
    },
    async onSubmit(event) {

      event.preventDefault();

      if (this.isCreateLoading) {
        return;
      }

      this.lineItemsValidation = false;
      const isFormCorrect = await this.v$.$validate();

      if (companyPurpose !== 'rent') {
        this.lineItemsValidation = this.hasLineItems;
      } else {
        this.lineItemsValidation = true;
      }

      if (!this.lineItemsValidation) {
        toastFailure('Please add a product or service to the order');
        return;
      }

      if (!this.isServicesOnly && !this.form.delivery && !this.form.pickup) {
        toastFailure('Please choose within delivery or pickup');
        return;
      }

      if (!isFormCorrect) {
        const hasFormErrors = this.v$.$errors.some(error => error.$uid && error.$uid.includes('form.'));

        if (hasFormErrors) {
          console.log('Validation failed', this.v$.$errors);
          return false;
        }

      }

      this.submitForm();
    },

    submitForm() {
      if (this.isCreateLoading) {
        return;
      }

      this.isCreateLoading = true;

      this.createSaleManually({
        user_id: this.form.customer ? this.form.customer.id : null,
        user_name: this.form.customer ? this.form.customer.name : '',
        user_email: this.form.customer ? this.form.customer.email : '',
        unit_id: this.form.unit != null ? this.form.unit.id : null,
        products: this.products,
        services: this.services,
        date: this.form.date,
        payment_status: this.form.payment_status.id,
        package_name: this.form.packageName,
        time: this.form.time ? this.form.time.value : this.getDefaultStartTime(),
        details: this.form.details,
        package_id: this.thisUnitPackageNameId[this.form.packageName] ?? null,
        duration: this.form.duration,
        subtotal: this.form.subtotal,
        shipping: this.form.shipping,
        description: this.form.description,
        customer_note: this.form.customer_note,
        pickup: this.form.pickup,
        repeat: this.form.repeat !== null ? (this.form.repeat_details == '' ? this.form.repeat : this.form.repeat + '=' + this.form.repeat_details) : null,
        paid: this.form.paid,
        payment_method: this.form.payment_method,
        send_invoice: this.form.send_invoice,
        discount: this.form.discount,
        time_interval: this.form.time_interval,

        customer_address_country_id: this.form.customer_address_country_id,
        customer_address_region_id: this.form.customer_address_region_id,
        customer_address_city: this.form.customer_address_city,
        customer_address_line_1: this.form.customer_address_line_1,
        customer_address_line_2: this.form.customer_address_line_2,
        customer_address_zip_code: this.form.customer_address_zip_code,
        customer_address_name: this.form.customer_address_name,
        customer_address_description: this.form.customer_address_description,
        customer_address_phone: this.form.customer_address_phone,
        customer_address_id: this.form.customer_address_id,

      }).then(() => {
        toastSuccess('A new ' + (companyPurpose !== 'rent' ? 'order' : 'booking') + ' has been created');
        this.$router.replace({ name: companyPurpose !== 'rent' ? 'orders' : 'bookings' });
      }).catch((error) => {
        console.log('error: ', error);
        toastFailure('Something went wrong while creating the ' + (companyPurpose !== 'rent' ? 'order' : 'booking'));
      }).finally(() => {
        this.isCreateLoading = false;
      });
    },
    dateDisabled(date) {
      if (this.units.length > 0) {
        return checkReservedDate(date, this.blockDates, this.form, this.units, this.thisUnitPackageNameId);
      } else {
        return false;
      }
    },
    disableSelectedDate(){
      this.unit.date = null;
      this.datepickerPlaceholder = 'Please select a new date';
    },
    loadBlockDates() {
      if (this.form.unit && this.form.packageName) {
        this.form.date = null
        this.datepickerPlaceholder = 'Loading...'
        this.isDatepickerDisabled = true
        axios.get(`api/sales/block-dates/${this.form.unit.id}/${this.form.packageName}`)
            .then(response => {

              this.datepickerPlaceholder = 'Please choose the date';
              const blockDates = {}

              for (const date of response.data) {

                if (this.form.date == date.date) {
                  this.disableSelectedDate();
                }
                if (!blockDates[date.date]) {
                  blockDates[date.date] = new Array();
                }

                blockDates[date.date].push(date);
              }

              this.blockDates = blockDates;
              this.datepickerPlaceholder = 'No date selected';
              this.isDatepickerDisabled = false;

              if (this.dateDisabled(this.form.date)) {
                this.disableSelectedDate();
              }
            })
            .catch((error) => {
              console.log(error);
              toastFailure('Something went wrong while loading reserved dates')
            })
      }
    },
    datepickerUpdated() {
      this.form.time = null
    },
    isSelectableBlocked(time) {
      if (this.blockDates[this.form.date]) {
        /* eslint-disable-next-line */
        return this.blockDates[this.form.date].includes(time) ? false : true
      }
      return true
    },
    timesDisabled(option) {
      return option.selectable
    },
    getDefaultStartTime() {
      return '00:00:00';
    }
  },
}
</script>

<style scoped>
.collapsible-field-label {
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
}

.collapsible-field-icon {
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .w-md-25 {
    width: 25% !important;
  }
}
</style>